<template>
  <div>
    <div class="mail-box-header">
      <form class="row" v-on:submit.prevent="searchZones()">
        <div class="col-lg-4">
          <div class="input-group col-lg-12">
            <input
              type="text"
              class="form-control"
              placeholder="buscar pelo nome"
              v-model="searchForm.form.zoneName"
            />
          </div>
        </div>

        <div class="col-lg-4">
          <div class="input-group-btn col-lg-12">
            <button type="submit" class="btn btn-sm btn-primary">
              <i class="fa fa-search"></i>
              Buescar
            </button>
          </div>
        </div>
      </form>
    </div>
    <div class="mail-box">
      <table class="table table-hover table-mail">
        <thead class="table-head">
          <tr>
            <th>Nome</th>
            <th>Tolerancia</th>
            <th>
              relacionado<br />
              com agenda
            </th>
            <th></th>
          </tr>
        </thead>

        <tbody class="table-list">
          <tr v-for="(zone, key) in zoneList.list" :key="key">
            <td>{{ zone.name }}</td>
            <td>
              <div class="input-group">
                <input
                  type="text"
                  class="form-control"
                  placeholder="Tolerancia"
                  v-model="zone.continuousTolerance"
                />
              </div>
            </td>
            <td @click.prevent="relateZone(zone._id, zone.continuousTolerance)">
              <switches
                v-model="zone.related"
                theme="bootstrap"
                color="success"
                :emit-on-mount="false"
              ></switches>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>
<script>
import Switches from 'vue-switches';
export default {
  components: { Switches },
  props: {
    selectedSchedule: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      searchForm: {
        form: {
          zoneName: '',
        },
      },
      selectedZone: '',
      continuousTolerance: '',
      zoneList: {
        originalList: [],
        list: [],
      },
    };
  },

  mounted() {
    this.ListZones();
  },
  watch: {
    'searchForm.form.zoneName'() {
      this.searchZones();
    },
    selectedSchedule() {
      this.ListZones();
    },
  },
  methods: {
    async ListZones() {
      const zones = await this.$store.dispatch('ZONE/ListAll');
      const formattedZones = zones.map(zone => ({
        ...zone,
        related: String(zone.tariffSchedule) === String(this.selectedSchedule),
      }));
      this.zoneList.originalList = formattedZones;
      this.searchZones();
    },
    searchZones() {
      const listFiltered = this.zoneList.originalList.filter(item => {
        return (
          item.name
            .toUpperCase()
            .indexOf(this.searchForm.form.zoneName.toUpperCase()) > -1
        );
      });
      this.zoneList.list = listFiltered;
    },
    async relateZone(zoneId, continuousTolerance) {
      try {
        if (!this.selectedSchedule) {
          return;
        }
        await this.$store.dispatch('RELATE/RelateZone', {
          tariffScheduleId: this.selectedSchedule,
          zoneId,
          continuousTolerance: continuousTolerance
            ? Number(continuousTolerance)
            : null,
        });
        await this.ListZones();
        this.$toasted.success('Zona relacionado com sucesso!');
      } catch (error) {
        this.$toasted.error('Não foi possível relacionar zona');
      }
    },
  },
};
</script>